import React from 'react';

import { useRandomIds } from '../../../helpers/shared';
import { Anchor, Checkbox, Container, Label } from './styles';

/**
 * Componente de checkbox para aceitar termos.
 * @param {object} props As propriedades do checkbox.
 * @param {boolean} props.isClicked Indica se o checkbox está marcado.
 * @param {string} props.id O ID único do checkbox.
 * @param {string} [props.role="checkbox"] O papel semântico do checkbox, geralmente "checkbox".
 * @param {number} [props.tabIndex=0] A ordem de tabulação do checkbox.
 * @param {boolean} props.aria-checked Indica se o estado do checkbox é marcado ou não para leitores de tela.
 * @param {boolean} [props.aria-required=true] Indica se o checkbox é obrigatório para leitores de tela.
 * @param {function} props.onKeyDown A função a ser executada ao pressionar teclas enquanto o checkbox está focado.
 * @returns {React.ReactNode} O componente do checkbox para termos.
 */
export function CheckboxTerm({ isClicked, error, ...props }) {
	const id = useRandomIds();
	const keyNames = ['Space', 'Enter', 'NumpadEnter'];
	return (
		<Container>
			<Checkbox
				{...props}
				isClicked={isClicked}
				id={id('checkbox-terms')}
				role="checkbox"
				tabIndex={0}
				aria-checked={isClicked}
				aria-required={true}
				onKeyDown={(event) => {
					if (keyNames.includes(event.code)) {
						props.onClick();
					}
				}}
			>
				{isClicked && '✓'}
				<Label htmlFor={id('checkbox-terms')}>
          Concordo com os{' '}
					<Anchor href={`${process.env.GATSBY_PUBLIC_URL_INSTITUCIONAL}/termos-de-uso`} target={'_blank'}>
            Termos de uso
					</Anchor>{' '}
          e<br></br>
					<Anchor href={`${process.env.GATSBY_PUBLIC_URL_INSTITUCIONAL}/politica-de-privacidade`} target={'_blank'}>
            Política de Privacidade
					</Anchor>{' '}
          da Lacrei Saúde
				</Label>
			</Checkbox>

			{error && <span>{error}</span>}
		</Container>
	);
}
